/** @flow */

// Deep copy of objects
// Use with caution It will NOT work for objects containing functions;
export const cloneObject = (obj: any) => {
  return obj ? JSON.parse(JSON.stringify(obj)) : obj;
};

// Returnes copy of provided object without null or undefined properties
// Warning! It will not check properties of nested objects
export const removeEmptyProperties = (obj: Object) => {
  if (!obj) {
    return obj;
  }

  return Object.entries(obj)
    .filter(([, value]) => value !== null && value !== undefined)
    .reduce(
      (newObj, [key, value]) => ({
        ...newObj,
        [key]: value,
      }),
      {},
    );
};

export function syntaxHighlight(obj: Object) {
  let jsonString = JSON.stringify(obj, undefined, 2);
  jsonString = jsonString
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
  return jsonString.replace(
    /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
    function(match) {
      var cls = "number";
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          cls = "key";
        } else {
          cls = "string";
        }
      } else if (/true|false/.test(match)) {
        cls = "boolean";
      } else if (/null/.test(match)) {
        cls = "null";
      }
      return '<span class="' + cls + '">' + match + "</span>";
    },
  );
}

export function arrayRemoveItem(arr: Array<any>, value: string | boolean | null) {
  const index = arr.indexOf(value);
  if (index > -1) arr.splice(index, 1);
  return arr;
}
